import React, { useState } from 'react';

import {
    Card,
    CardContent,
    CardActions,
    Typography,
    Button,
    Box
} from '@mui/material';

import PatientInfo from './PatientInfo';
import AddNewPatient from './AddPatient';


export default function Room({
    id,
    patients,
    addPatient,
    deletePatient
}) {

    const [showInsertion, setShowInsertion] = useState(false);

    const [newPatient, setNewPatient] = useState({
        name: "",
        diagnosi: [""]
    });


    const removeUser = async (patientId) => {

        try {

            await deletePatient(id, patientId);

        } catch (error) {

            console.error(
                "Errore durante l'eliminazione del paziente:",
                error
            );

        }

    };


    const save = async (patient) => {

        if (!patient.name.trim()) {
            return;
        }

        const patientToSave = {
            name: patient.name.trim(),

            diagnosi: patient.diagnosi.filter(
                d => d.trim() !== ""
            )
        };


        try {

            await addPatient(id, patientToSave);

            setNewPatient({
                name: "",
                diagnosi: [""]
            });

            setShowInsertion(false);

        } catch (error) {

            console.error(
                "Errore durante l'aggiunta del paziente:",
                error
            );

        }
    };


    return (

        <Card
            sx={{
                width: "100%",
                marginBottom: 10,
                boxShadow: 1
            }}
        >

            <CardContent sx={{ p: 3 }}>

                <Typography
                    gutterBottom
                    variant="h5"
                    fontWeight="bold"
                    sx={{ mb: 3 }}
                >
                    Stanza {id}
                </Typography>


                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        gap: 3,
                        width: "100%",
                        overflowX: "auto",
                        pb: 1
                    }}
                >

                    {patients.map((paziente) => (

                        <PatientInfo
                            key={paziente.id}
                            data={paziente}
                            removeHandler={removeUser}
                        />
   
                    ))}

                </Box>

            </CardContent>


            {patients.length < 3 && (

                <CardActions
                    sx={{
                        px: 3,
                        pb: 3
                    }}
                >

                    <Button
                        onClick={() => setShowInsertion(true)}
                        size="medium"
                        variant="outlined"
                    >
                        Aggiungi paziente
                    </Button>

                </CardActions>

            )}


            {showInsertion && (

                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        bgcolor: 'rgba(0,0,0,0.6)',
                        zIndex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >

                    <Box
                        sx={{
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            p: 4,
                            maxHeight: '90%',
                            overflowY: 'auto',
                            boxShadow: 24,
                            width: '90%',
                            maxWidth: '55ch',
                        }}
                    >

                        <AddNewPatient
                            patient={newPatient}
                            setPatient={setNewPatient}
                        />


                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                mt: 2
                            }}
                        >

                            <Button
                                variant="contained"
                                sx={{ mr: 2 }}
                                color="error"
                                onClick={() => {

                                    setShowInsertion(false);

                                    setNewPatient({
                                        name: "",
                                        diagnosi: [""]
                                    });

                                }}
                            >
                                Chiudi
                            </Button>


                            <Button
                                variant="contained"
                                onClick={() => save(newPatient)}
                            >
                                Salva
                            </Button>

                        </Box>

                    </Box>

                </Box>

            )}

        </Card>
    );
}